import {
  frameThickness,
  glassHingeWidth,
  glassHingeHeight,
  glassLockWidth,
  glassLockHeight,
} from '@/shared/config/model-constants'
import type { ModelData } from '@/shared/stores/model-utils'

export const model7InitialModel: ModelData = {
  name: 'Template 7 - Symmetrical Quad Door System',
  modelId: 'model7',
  type: 'DOOR',
  description: '7-variant door with symmetrical layout and quad door opening',
  width: 4500,
  height: 2500,
  photoId: null,
  serviceNames: [],
  serviceIds: [],
  parameters: [
    // Frame profiles
    {
      positionId: 'top_frame_profile',
      type: 'PROFILE',
      width: 4500,
      height: frameThickness,
      thickness: 2,
      color: '#ffffff',
      material: '',
      materialId: null,
      position: { x: 0, y: 0, z: 0 },
    },
    {
      positionId: 'bottom_left_frame_profile',
      type: 'PROFILE',
      width: 300,
      height: frameThickness,
      thickness: 2,
      color: '#ffffff',
      material: '',
      materialId: null,
      position: { x: 0, y: 2440, z: 0 },
    },
    {
      positionId: 'bottom_center_frame_profile',
      type: 'PROFILE',
      width: 660,
      height: frameThickness,
      thickness: 2,
      color: '#ffffff',
      material: '',
      materialId: null,
      position: { x: 1920, y: 2440, z: 0 },
    },
    {
      positionId: 'bottom_right_door_frame_profile',
      type: 'PROFILE',
      width: 1620,
      height: frameThickness,
      thickness: 2,
      color: '#ffffff',
      material: '',
      materialId: null,
      position: { x: 2580, y: 2440, z: 0 },
    },
    {
      positionId: 'bottom_right_frame_profile',
      type: 'PROFILE',
      width: 300,
      height: frameThickness,
      thickness: 2,
      color: '#ffffff',
      material: '',
      materialId: null,
      position: { x: 4200, y: 2440, z: 0 },
    },
    {
      positionId: 'left_frame_profile',
      type: 'PROFILE',
      width: frameThickness,
      height: 2500,
      thickness: 2,
      color: '#ffffff',
      material: '',
      materialId: null,
      position: { x: 0, y: 0, z: 0 },
    },
    {
      positionId: 'right_frame_profile',
      type: 'PROFILE',
      width: frameThickness,
      height: 2500,
      thickness: 2,
      color: '#ffffff',
      material: '',
      materialId: null,
      position: { x: 4440, y: 0, z: 0 },
    },
    // Glass panels
    {
      positionId: 'left_glass_panel',
      type: 'GLASS',
      width: 240,
      height: 2380,
      thickness: 6,
      color: 'rgba(255, 255, 255, 0.02)',
      material: 'clear_glass',
      materialId: null,
      isDouble: false,
      position: { x: frameThickness, y: frameThickness, z: 0 },
    },
    {
      positionId: 'left_door_top_glass_panel',
      type: 'GLASS',
      width: 1620,
      height: 380,
      thickness: 6,
      color: 'rgba(255, 255, 255, 0.02)',
      material: 'clear_glass',
      materialId: null,
      isDouble: false,
      position: { x: 300, y: frameThickness, z: 0 },
    },
    {
      positionId: 'left_door_glass_panel_1',
      type: 'GLASS',
      width: 810,
      height: 2060,
      thickness: 6,
      color: 'rgba(255, 255, 255, 0.02)',
      material: 'clear_glass',
      materialId: null,
      isDouble: false,
      position: { x: 300, y: 440, z: 0 },
      hardware: {
        handles: [
          {
            positionId: 'left_door_1_vertical_handle',
            type: 'VERTICAL_HANDLE',
            width: 30,
            height: 200,
            thickness: 10,
            color: '#333333',
            material: 'aluminum',
            materialId: null,
            position: { x: 810 - (frameThickness + 30), y: 940, z: 10 },
          },
        ],
        hinges: [
          {
            positionId: 'door_1_left_top_hinge_1',
            type: 'HINGE',
            width: glassHingeWidth,
            height: glassHingeHeight,
            thickness: 10,
            color: '#C0C0C0',
            material: '',
            materialId: null,
            position: { x: -glassHingeWidth / 3, y: -glassHingeHeight / 2, z: 10 },
          },
          {
            positionId: 'door_1_left_bottom_hinge_2',
            type: 'HINGE',
            width: glassHingeWidth,
            height: glassHingeHeight,
            thickness: 10,
            color: '#C0C0C0',
            material: '',
            materialId: null,
            position: { x: 0, y: 2060 - glassHingeHeight, z: 10 },
          },
        ],
        locks: [
          {
            positionId: 'door_1_right_lock',
            type: 'LOCK',
            width: glassLockWidth,
            height: glassLockHeight,
            thickness: 10,
            color: '#C0C0C0',
            material: '',
            materialId: null,
            position: { x: 800 - glassLockWidth * 1.5, y: 2060 - glassLockHeight, z: 10 },
          },
        ],
      },
    },
    {
      positionId: 'left_door_glass_panel_2',
      type: 'GLASS',
      width: 810,
      height: 2060,
      thickness: 6,
      color: 'rgba(255, 255, 255, 0.02)',
      material: 'clear_glass',
      materialId: null,
      isDouble: false,
      position: { x: 1110, y: 440, z: 0 },
      hardware: {
        handles: [
          {
            positionId: 'left_door_2_vertical_handle',
            type: 'VERTICAL_HANDLE',
            width: 30,
            height: 200,
            thickness: 10,
            color: '#333333',
            material: 'aluminum',
            materialId: null,
            position: { x: frameThickness, y: 940, z: 10 },
          },
        ],
        hinges: [
          {
            positionId: 'door_2_right_top_hinge_1',
            type: 'HINGE',
            width: glassHingeWidth,
            height: glassHingeHeight,
            thickness: 10,
            color: '#C0C0C0',
            material: '',
            materialId: null,
            position: { x: 800 - glassHingeWidth / 2, y: -glassHingeHeight / 2, z: 10 },
          },
          {
            positionId: 'door_2_right_bottom_hinge_2',
            type: 'HINGE',
            width: glassHingeWidth,
            height: glassHingeHeight,
            thickness: 10,
            color: '#C0C0C0',
            material: '',
            materialId: null,
            position: { x: 800 - glassHingeWidth, y: 2060 - glassHingeHeight, z: 10 },
          },
        ],
        locks: [
          {
            positionId: 'door_2_left_lock',
            type: 'LOCK',
            width: glassLockWidth,
            height: glassLockHeight,
            thickness: 10,
            color: '#C0C0C0',
            material: '',
            materialId: null,
            position: { x: glassLockWidth, y: 2060 - glassLockHeight, z: 10 },
          },
        ],
      },
    },
    {
      positionId: 'center_glass_panel',
      type: 'GLASS',
      width: 660,
      height: 2380,
      thickness: 6,
      color: 'rgba(255, 255, 255, 0.02)',
      material: 'clear_glass',
      materialId: null,
      isDouble: false,
      position: { x: 1920, y: frameThickness, z: 0 },
    },
    {
      positionId: 'right_door_glass_panel_1',
      type: 'GLASS',
      width: 810,
      height: 2060,
      thickness: 6,
      color: 'rgba(255, 255, 255, 0.02)',
      material: 'clear_glass',
      materialId: null,
      isDouble: false,
      position: { x: 2580, y: 440, z: 0 },
      hardware: {
        handles: [
          {
            positionId: 'right_door_1_vertical_handle',
            type: 'VERTICAL_HANDLE',
            width: 30,
            height: 200,
            thickness: 10,
            color: '#333333',
            material: 'aluminum',
            materialId: null,
            position: { x: 810 - (frameThickness + 30), y: 940, z: 10 },
          },
        ],
        hinges: [
          {
            positionId: 'door_1_left_top_hinge_1',
            type: 'HINGE',
            width: glassHingeWidth,
            height: glassHingeHeight,
            thickness: 10,
            color: '#C0C0C0',
            material: '',
            materialId: null,
            position: { x: -glassHingeWidth / 3, y: -glassHingeHeight / 2, z: 10 },
          },
          {
            positionId: 'door_1_left_bottom_hinge_2',
            type: 'HINGE',
            width: glassHingeWidth,
            height: glassHingeHeight,
            thickness: 10,
            color: '#C0C0C0',
            material: '',
            materialId: null,
            position: { x: 0, y: 2060 - glassHingeHeight, z: 10 },
          },
        ],
        locks: [
          {
            positionId: 'door_1_right_lock',
            type: 'LOCK',
            width: glassLockWidth,
            height: glassLockHeight,
            thickness: 10,
            color: '#C0C0C0',
            material: '',
            materialId: null,
            position: { x: 800 - glassLockWidth * 1.5, y: 2060 - glassLockHeight, z: 10 },
          },
        ],
      },
    },
    {
      positionId: 'right_door_glass_panel_2',
      type: 'GLASS',
      width: 810,
      height: 2060,
      thickness: 6,
      color: 'rgba(255, 255, 255, 0.02)',
      material: 'clear_glass',
      materialId: null,
      isDouble: false,
      position: { x: 3390, y: 440, z: 0 },
      hardware: {
        handles: [
          {
            positionId: 'right_door_2_vertical_handle',
            type: 'VERTICAL_HANDLE',
            width: 30,
            height: 200,
            thickness: 10,
            color: '#333333',
            material: 'aluminum',
            materialId: null,
            position: { x: frameThickness, y: 940, z: 10 },
          },
        ],
        hinges: [
          {
            positionId: 'door_2_right_top_hinge_1',
            type: 'HINGE',
            width: glassHingeWidth,
            height: glassHingeHeight,
            thickness: 10,
            color: '#C0C0C0',
            material: '',
            materialId: null,
            position: { x: 800 - glassHingeWidth / 2, y: -glassHingeHeight / 2, z: 10 },
          },
          {
            positionId: 'door_2_right_bottom_hinge_2',
            type: 'HINGE',
            width: glassHingeWidth,
            height: glassHingeHeight,
            thickness: 10,
            color: '#C0C0C0',
            material: '',
            materialId: null,
            position: { x: 800 - glassHingeWidth, y: 2060 - glassHingeHeight, z: 10 },
          },
        ],
        locks: [
          {
            positionId: 'door_2_left_lock',
            type: 'LOCK',
            width: glassLockWidth,
            height: glassLockHeight,
            thickness: 10,
            color: '#C0C0C0',
            material: '',
            materialId: null,
            position: { x: glassLockWidth, y: 2060 - glassLockHeight, z: 10 },
          },
        ],
      },
    },
    {
      positionId: 'right_door_top_glass_panel',
      type: 'GLASS',
      width: 1620,
      height: 380,
      thickness: 6,
      color: 'rgba(255, 255, 255, 0.02)',
      material: 'clear_glass',
      materialId: null,
      isDouble: false,
      position: { x: 2580, y: frameThickness, z: 0 },
    },
    {
      positionId: 'right_glass_panel',
      type: 'GLASS',
      width: 240,
      height: 2380,
      thickness: 6,
      color: 'rgba(255, 255, 255, 0.02)',
      material: 'clear_glass',
      materialId: null,
      isDouble: false,
      position: { x: 4200, y: frameThickness, z: 0 },
    },
  ],
  doorConfiguration: {
    type: 'quad_door',
    totalDoorWidth: 3240,
    individualDoorWidth: [810, 810, 810, 810],
    totalHandles: 4,
    openingDirection: 'center_opening',
    hingePosition: 'center_split',
  },
}
